/**
 * Remove apenas dados de rascunho / palco do Geppetto no localStorage.
 * Não remove sessão (gepetto_user / gepetto_token), tema, idioma nem avisos de plugins Moodle.
 */

const LAST_OPEN_KEY = 'gepetto_last_open_layout';

function shouldRemoveKey(key) {
  if (!key) return false;
  if (key === LAST_OPEN_KEY) return true;
  if (key === 'gepetto_rows' || key === 'gepetto_courseInfo') return true;
  if (key.startsWith('gepetto_draft_')) return true;
  if (key.startsWith('gepetto_free_local_projects_v1_')) return true;
  return false;
}

/** @returns {number} quantidade de chaves removidas */
export function clearGepettoBuilderLocalCache() {
  if (typeof window === 'undefined' || !window.localStorage) return 0;
  const keys = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (shouldRemoveKey(k)) keys.push(k);
    }
    keys.forEach((k) => {
      try {
        localStorage.removeItem(k);
      } catch (_) { /* noop */ }
    });
  } catch (_) {
    return 0;
  }
  return keys.length;
}
